import { Component, OnInit, ViewChild } from '@angular/core';
import { BookPageComponent } from '../../../shared/components/book-page/book-page.component';
import { Router } from '@angular/router';
import { RecSearchService } from '../../rec-search-service';
import { Store } from '@ngrx/store';

import * as BPActions from './../../../store/actions/bookpage.action';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { NgForm, FormGroup, UntypedFormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-rec-bp-search',
  providers: [RecSearchService],
  templateUrl: './rec-bp-search.component.html',
  styleUrls: ['./rec-bp-search.component.css']
})
export class RecBpSearchComponent implements OnInit {

  @ViewChild(BookPageComponent, { static: false }) bookpageChild;
  @ViewChild('f', { static: true }) bookPageSearchForm: NgForm;
  parentForm: FormGroup;
  public bookType: string = '';
  public test: string = 'xxx'; 
  message: any;

  constructor(private router: Router, private service: RecSearchService, private store: Store<AppState>, private fb: FormBuilder) {
    this.bookType = 'Deeds';
  }

  addRecToStore(book, page) {
    this.store.dispatch(new BPActions.AddBP(
      { docNumPrimary: book, docNumSecondary: page }));
  }

  delRecFromStore(index) {
    this.store.dispatch(new BPActions.RemoveBP(index));
  }


  search(url) {

    this.delRecFromStore(0);

    this.addRecToStore(this.bookpageChild.utilityobj.docNumPrimary, this.bookpageChild.utilityobj.docNumSecondary);

    this.router.navigate(['/rec-bp-doc-disp-pg', this.bookpageChild.utilityobj.docNumPrimary, this.bookpageChild.utilityobj.docNumSecondary]);

  }

  ngOnInit() {
    //this.parentForm = this.fb.group({
    //});

    //this.bookPageSearchForm.form = this.fb.group({});

  }

  onSubmit(e) {
    if (this.bookPageSearchForm.valid) {

      this.delRecFromStore(0);

      this.addRecToStore(
        this.bookpageChild.utilityobj.docNumPrimary,
        this.bookpageChild.utilityobj.docNumSecondary);

      console.log(this.bookpageChild.utilityobj.docNumSecondary)
       this.router.navigate(['/rec-bp-doc-disp-pg', this.bookpageChild.utilityobj.docNumPrimary, this.bookpageChild.utilityobj.docNumSecondary]);


    }
    else {
      this.validateAllFormFields(this.bookPageSearchForm.form);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  ngAfterViewInit() {

    this.parentForm = this.fb.group({
    });

    this.bookPageSearchForm.form = this.fb.group({});

    this.bookPageSearchForm.form.addControl('bookPageForm', this.bookpageChild.form);
    this.bookpageChild.form.setParent(this.bookPageSearchForm.form);
  }
}
